import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

export default class HeroSlides {
	constructor() {
		this.swiper = undefined;
	}

	init() {
		if ($('.hero-slider__slides')[0]) {
			this.swiper = new Swiper('.hero-slider__slides', {
				loop: true,
				modules: [Autoplay, EffectFade],
				slidesPerView: 1,
				spaceBetween: 0,
				speed: 600,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				}
			});
		}
	}

	destroy() {
		if (this.swiper !== undefined) {
			this.swiper.destroy();
		}
	}
}
